export const pathVariants1 = {
  hidden: {
    opacity: 0,
    fill: "none",
    stroke: "none",
    strokeWidth: "1px",
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
  visible2: {
    opacity: 1,
    pathLength: 1,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "2px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

export const pathVariants2 = {
  hidden: {
    opacity: 0,
    fill: "none",
    stroke: "none",
    strokeWidth: "8px",
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: "none",
    stroke: "#fff",

    strokeWidth: "15px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
  visible2: {
    opacity: 1,
    pathLength: 0,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "15px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

export const pathVariants3 = {
  visible: {
    scale: [0, 1],
    transition: {
      duration: 0.5,
      yoyo: Infinity,
      ease: "easeInOut",
    },
  },
  visible2: {
    scale: 0,
    transition: {
      duration: 0.5,
      ease: "easeInOut",
    },
  },
};

export const pathVariants5 = {
  hidden: {
    opacity: 0,
    fill: "none",
    stroke: "none",
    strokeWidth: "0.5px",
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "0.5px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
  visible2: {
    opacity: 1,
    pathLength: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "8px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

export const pathVariants4 = {
  hidden: {
    opacity: 0,
    fill: "none",
    stroke: "none",
    strokeWidth: "2px",
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    fill: "none",
    stroke: "#fff",
    strokeWidth: "2px",
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};
